var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"},attrs:{"id":"app"}},[(_vm.getLayout === 'default')?_c('DefaultLayout',[_c('router-view')],1):_vm._e(),(_vm.getLayout === 'plain')?_c('PlainLayout',[_c('router-view')],1):_vm._e(),_c('ActiveCustomerHandler')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }